import {LogEventInfo} from "typing/message";

export const enum LinkEnum {
    ADMIN_LEGACY,
}

export const LINK_MAP = new Map<LinkEnum, string>([[LinkEnum.ADMIN_LEGACY, "%s/admin/dashboard/tickets/view?TicketID=%s"]]);

export const OwnerSummaryTopicMapping = {
    rates: "Revenue Performance",
    guests: "Guest Issues",
    administrative: "Account Management",
    termination: "Termination Risk",
};

export const enum LogEventEnum {
    CATEGORICAL_SENTIMENTS_LOADED = "CATEGORICAL_SENTIMENTS_LOADED",
}

export const LOG_EVENT_DATA: Record<LogEventEnum, LogEventInfo> = {
    [LogEventEnum.CATEGORICAL_SENTIMENTS_LOADED]: {target: "categorical sentiments", action: "loaded", plural: true},
};

export const enum DEFAULT_MESSAGE {
    UNIT_ID = "Oops! The Unit ID you entered seems to be invalid. Please double-check it and try again. Need help? Reach out to our support team!",
    CATEGORICAL_SENTIMENTS = "Oops! We couldn’t find any categorical sentiments for your input. Please try again with different data or contact our support team for assistance.",
    ERROR = "There was an error while obtaining the summary, please retry to see if that fixes the issue.",
}
